import { render, staticRenderFns } from "./InsuranceComplianceOverview.vue?vue&type=template&id=6394f93f&scoped=true"
import script from "./InsuranceComplianceOverview.vue?vue&type=script&lang=js"
export * from "./InsuranceComplianceOverview.vue?vue&type=script&lang=js"
import style0 from "./InsuranceComplianceOverview.vue?vue&type=style&index=0&id=6394f93f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6394f93f",
  null
  
)

export default component.exports